// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  app: `app 1`,
  messages: {
    'default': {
      title: 'Something went wrong…',
      body: 'An unexpected error occurred',
      button: 'Ok',
    },
    '00001': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00002': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00003': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00004': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00005': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00006': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00007': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00008': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00009': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00010': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00011': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00012': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00013': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00014': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00015': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00016': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00017': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00018': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00019': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00020': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00021': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00022': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00023': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00024': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00025': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00026': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00027': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00028': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00029': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00030': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00031': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00032': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00033': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00034': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00035': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00036': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00037': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00038': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00039': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00040': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00041': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00042': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00043': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00044': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00045': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00046': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00047': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00048': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00049': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00050': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00051': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00052': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00053': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00054': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00055': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00056': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00057': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00058': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00059': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00060': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00061': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00062': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00063': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00064': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00065': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00066': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00067': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00068': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00069': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00070': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00071': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00072': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00073': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00074': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00075': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00076': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00077': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00078': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00079': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00080': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00081': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00082': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00083': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00084': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00085': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00086': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00087': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00088': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00089': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00090': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00091': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00092': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00093': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00094': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00095': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00096': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00097': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00098': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00099': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00100': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00101': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00102': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00103': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00104': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00105': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00106': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00107': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00108': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00109': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00110': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00111': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00112': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00113': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00114': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00115': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00116': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00117': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00118': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00119': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00120': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00121': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00122': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00123': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00124': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00125': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00126': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00127': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00128': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00129': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00130': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00131': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00132': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00133': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00134': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00135': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00136': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00137': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00138': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00139': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00140': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00141': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00142': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00143': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00144': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00145': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00146': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00147': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00148': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00149': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00150': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00151': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00152': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00153': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00154': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00155': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00156': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00157': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00158': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00159': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00160': {
      title: '😱 Error processing your payment',
      body: 'We recommend you: Review the information entered, contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00161': {
      title: 'Your payment cannot be made',
      body: 'Contact your bank or try another payment method to try again.',
      button: 'Ok',
    },
    '00162': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00163': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00164': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00165': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00166': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00167': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00168': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00180': {
      title: 'Something went wrong…',
      body: 'Account does not have enough funds.',
      button: 'Ok',
    },
    '00181': {
      title: 'Something went wrong…',
      body: 'Payment pending.',
      button: 'Ok',
    },
    '00182': {
      title: 'Something went wrong…',
      body: 'Bin not found.',
      button: 'Ok',
    },
    '00182': {
      title: 'Something went wrong…',
      body: 'The number of payment retries has been exceeded, please try making another purchase or contact us.',
      button: 'Ok',
    },
    '00200': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00201': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00202': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00203': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00204': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00205': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00206': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00207': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00208': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00209': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00210': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00211': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00212': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00213': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00214': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00215': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00216': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00217': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00218': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00219': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00220': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00221': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00222': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00223': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00224': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00225': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00226': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00227': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00228': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00229': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00230': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00300': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00301': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00302': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00303': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00304': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00305': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00306': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00307': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00308': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00309': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00310': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00311': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00312': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00313': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00314': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00315': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00316': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00317': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00318': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00319': {
      title: 'Something went wrong…',
      body: 'Sorry, we are unable to process your payment at this time, please try again. If the error persists, send us an email to: servicio@boletia.com',
      button: 'Ok',
    },
    '00333': {
      title: 'Estos boletos volaron!',
      body: 'Lo sentimos, los boletos han sido comprados por alguien más. Intenta con otra zona y no te pierdas del evento.',
      button: 'Entendido',
    },
    '00334': {
      title: '¡Estos boletos volaron!',
      body: 'Lo sentimos, los boletos han sido comprados por alguien más. Intenta con otra zona y no te pierdas del evento.',
      button: 'Entendido',
    },
    '00335': {
      title: '¡Estos boletos volaron!',
      body: 'Lo sentimos, los boletos han sido comprados por alguien más. Intenta con otra zona y no te pierdas del evento.',
      button: 'Entendido',
    },
    '00336': {
      title: '¡Estos boletos volaron!',
      body: 'Lo sentimos, los boletos han sido comprados por alguien más. Intenta con otra zona y no te pierdas del evento.',
      button: 'Entendido',
    },
    '00337': {
      title: '¡Estos boletos volaron!',
      body: 'Lo sentimos, los boletos han sido comprados por alguien más. Intenta con otra zona y no te pierdas del evento.',
      button: 'Entendido',
    },
    '00338': {
      title: '¡Ups!',
      body: 'Lo sentimos, ya no quedan boletos disponibles en la zona selecionada.',
      button: 'Entendido',
    },
    '00400': 'object not received to do the action',
    '00401': 'user invalid code',
    '00402': 'user not found',
    '00403': 'incomplete data to perform a refresh token',
    '00404': 'cache process error',
    '00405': 'error reading the body',
    '00406': 'marshall process error',
    '00407': 'unmarshall process error',
    '00408': 'validation error',
    '00409': 'this username already exists',
    '00410': 'this email or phone number al ready exists',
    '00411': 'verification code fails to deliver successfully',
    '00412': "the provided code doesn't match what the server was expecting",
    '00413': 'two or more modifications are happening concurrently',
    '00414': 'the provider is already supported',
    '00415':
      'there is a code mismatch and the service fails to configure the software token TOTP multi-factor authentication (MFA)',
    '00416': 'code has expired',
    '00417': 'group already exists',
    '00418': 'internal error',
    '00419': "isn't allowed to use your email identity",
    '00420': 'invalid Lambda response',
    '00421': 'the specified OAuth flow is not valid',
    '00422': 'invalid parameter',
    '00423': 'invalid password',
    '00424':
      "the role provided for SMS configuration doesn't have permission to publish using Amazon SNS",
    '00425':
      'the trust relationship is not valid for the role provided for SMS configuration',
    '00426': 'user pool configuration is not vali',
    '00427':
      'a user exceeds the limit for a requested Amazon Web Services resource',
    '00428': "can't find a multi-factor authentication (MFA) method",
    '00429': "user isn't authorized",
    '00430': 'a password reset is required',
    '00431': 'precondition is not met',
    '00432': "can't find the requested resource",
    '00433': "the specified scope doesn't exist",
    '00434':
      "the software token time-based one-time password (TOTP) multi-factor authentication (MFA) isn't activated for the user pool",
    '00435': 'the user has made too many failed attempts for a given action',
    '00436': 'the user has made too many requests for a given operation',
    '00437': "the request isn't authorized",
    '00438': 'unexpected exception with Lambda',
    '00439': "the specified identifier isn't supported",
    '00440':
      "you attempt to perform an operation that isn't enabled for the user pool client",
    '00441': 'unsupported token is passed to an operation',
    '00442': 'the user is in an unsupported state',
    '00443':
      "you're trying to modify a user pool while a user import job is in progress for that pool",
    '00444': 'user validation exception with the Lambda service',
    '00445': "user isn't confirmed successfully",
    '00446': "user isn't found",
    '00447': "user pool add-ons aren't enabled",
    '00448': "user pool tag can't be set or updated",
    '00449':
      'You have exceeded the number of login attempts, please come back in 15 minutes.',
    '00450': 'User role error, only seller is allowed to perform this action',
    '00500': 'object not received to do the action',
    '00501': 'validation error',
    '00502': 'storage service is down',
    '00503': 'query error',
    '00504': 'cache service is down',
    '00505': 'cache process error',
    '00506': 'marshall process error',
    '00507': 'unmarshall process error',
    '00600': 'object not received to do the action',
    '00601': 'validation error',
    '00602': 'the secret parameter is missing',
    '00603': 'the secret parameter is invalid or malformed',
    '00604': 'the response parameter is missing',
    '00605': 'the response parameter is invalid or malformed',
    '00606': 'the request is invalid or malformed',
    '00607':
      'the response is no longer valid: either is too old or has been used previously',
    '00608': 'the keys entered are incorrect',
    '00609': 'lower received score than expected',
  },
  billboards: {
    eventTags: {
      today: 'Today!',
      next: 'Next!',
      new: 'New!',
      lastDay: 'Last day!',
      notMiss: 'Do not miss',
      promo: 'Promo',
      soldOut: 'Sold out',
    },
  },
  checkout: {
    paths: {
      home: 'Tickets',
      auth: 'Register',
      customization: "Who's going?",
      payment: 'Pay your tickets',
      success: 'You already have your tickets!',
      thanks: 'Thanks',
    },
    thanks: {
      title: 'Thank you!',
      message: 'Thanks for your visit.',
    },
    forms: {
      validations: {
        max: '{{label}} must have maximum {{max}} characters',
        min: '{{label}} must have at least {{min}} characters',
        required: '{{label}} it is mandatory',
        email: 'Incorrect email format',
      },
      fields: {
        name: 'Name',
        holder: 'Holder',
        email: 'Email',
        phone: 'Phone',
        password: 'Password',
        lastName: 'Last name',
        creditCard: 'Card',
        validity: 'Validity',
        validityDate: 'Expiration date (MM/YY)',
        zipCode: 'Zip code',
        country: 'Country',
        state: 'State',
        city: 'City',
        coupon: 'Coupon',
        date: 'Date',
      },
      buttons: {
        next: 'Next',
      },
    },
    buttons: {
      continue: 'Continue',
      continuePurchase: 'Continue shopping',
      searchAnotherArea: 'Search in another area',
      clearTickets: 'Clear tickets',
      orderByPrice: 'Sort by price',
      confirm: 'Confirm',
      save: 'Keep',
      change: 'Change',
      activeCoupon: 'Activate coupon',
      apply: 'Apply',
      retry: 'Retry',
      searchOtherZone: 'Search in another area',
      login: 'Login',
      loginSeller: 'Iniciar sesión como vendedor',
      buyTickets_one: 'Buy {{count}} ticket',
      buyTickets_other: 'Buy {{count}} tickets',
    },
    global: {
      aboutEvent: 'About the event',
      about: 'About',
      more: 'Learn more',
      subtotal: 'Subtotal',
      noPromo: 'No discount',
      charge: 'Service charges',
      paymentMethodCharge: 'Payment method',
      ticketFee: 'Ticketing fee',
      paymentProcessor: 'Payment processor',
      ReviewPurchase: 'Order summary',
      place: 'Location',
      sponsors: 'Sponsors',
      ContactOrganizer: 'Contact the organizer',
      readMore: 'See more',
      readLess: 'see less',
      viewLocation: 'See location',
      eventOnline: 'Online event',
      addCalendar: 'Add to calendar',
      moreEventInfo: '+ More information about the event',
      acceptLabel: 'Accept',
      cancelLabel: 'Cancel',
      here: 'here',
      search: 'Look for...',
      category: 'Category',
      city: 'City',
      seeAll: 'See all',
      from: 'From',
      buy: 'Buy',
      buyTickets: 'Buy tickets',
      price: 'Price',
      filters: 'Filters',
      filterEvents: 'Filter Events',
      clearFilters: 'Clean filters',
      applyFilters: 'Apply filters',
      up: 'Back to top',
      dates: 'Dates',
      start: 'Start',
      end: 'Finish',
      row: 'Row',
      seat: 'Seat',
      ticket: 'Ticket',
      yourTickets: 'Your tickets',
      total: 'Total',
      terms: 'Terms and Conditions',
      termsPurchase: 'Purchase Terms',
      privacyNotice: 'Privacy Notice',
      needHelp: 'Do you need help?',
      remainingTime: 'Remaining time',
      ticketsFly: 'Tickets are flying',
      madeIn: 'Made in Mexico with 🔥 by Boletia S.A de C.v. ',
      checkoutEnd: 'Your purchasing process has ended',
      noTickets: 'You have not selected your tickets',
      pleaseSelectTickets:
        'Please select your tickets and continue with the purchase process',
      checkOtherEvents: 'Check other events at boletia.com',
      differentEvent: 'This event is different from the original',
      noSendCode: 'You have not sent any code',
      yourTickets2: 'Your tickets!',
      reserveYourSpot: 'Reserve your spot now!',
      addYourTickets: 'Add your tickets to the event.',
      noDate: 'Undated',
      rangeTimeOneDay: 'of {{startTime}} to {{endTime}}',
      rangeTime: 'of {{startTime}} to the {{endTime}}',
      noAvailability_one:
        'There is no {{count}} available seat in this area, you can try again with fewer tickets or go back and look in a different area.',
      noAvailability_other:
        'There is no {{count}} seats available in this area, you can try again with fewer tickets or go back and look in a different area.',
    },
    modals: {
      onDeleteTicket: {
        title: 'Do you want to delete pre-selected seats?',
        text: 'This way you can choose new seats.',
        acceptLabel: 'Delete selection',
      },
      onHoldTokenExpired: {
        title: 'Expired time',
        text: "We're sorry, your purchase time has expired.",
        acceptLabel: 'Accept',
      },
      onMaxTickets: {
        title: 'Limit exceeded',
        text: 'Sorry, you can only select {{max}} tickets at most.',
        acceptLabel: 'Accept',
      },
      checkAvailability: {
        title: 'Last tickets available!',
        text: 'This area has only {{availability}} tickets available. ',
        acceptLabel: 'Continue shopping',
        cancelLabel: 'Choose other tickets',
      },
      checkAvailabilityRSVP: {
        title: 'Last tickets available!',
        text: 'This area has only {{availability}} tickets available. ',
        acceptLabel: 'Continue shopping',
        cancelLabel: 'Choose other tickets',
      },
      checkMinPerSale: {
        title: 'Minimum purchase',
        text: 'You must buy at least {{minPerSel}} tickets in this area.  {{minPerSel}} tickets?',
        acceptLabel: 'Continue shopping',
        cancelLabel: 'Choose other tickets',
      },
      clearSelection: {
        title: 'Delete selection',
        text: 'Deleting your tickets will remove them from your selection and you will be able to select them again',
        acceptLabel: 'Delete selection',
      },
      onBestAvailableFail: {
        message: 'The tickets have been purchased by someone else. ',
        title: 'These tickets flew!',
        label: 'See other areas',
      },
      setBookingMode: {
        title: 'Warning',
        text: 'You already have tickets selected, if you change your view you will lose your tickets. ',
        cancelLabel: 'Cancel',
        acceptLabel: 'Accept',
      },
      timeExpired: {
        title: 'Expired time',
        text: "We're sorry, your purchase time has expired.",
        acceptLabel: 'Accept',
      },
      onBackButtonEvent: {
        title: 'Warning',
        text: 'You already have tickets selected, if you change your view you will lose your tickets. ',
        cancelLabel: 'Cancel',
        acceptLabel: 'Accept',
      },
      INVALID_SESSION_TOKEN: {
        title: 'Session Expired',
        body: 'Your session has expired. Please refresh the page to continue with your purchase.',
        acceptLabel: 'Refresh Page',
      },
      PAYMENT_AMOUNT_MISMATCH: {
        title: "We couldn't process your payment",
        text: 'Select the number of installments again and retry to complete your purchase. No charge was made for this attempt.',
        acceptLabel: 'Got it',
      },
      BOOKING_OXXO_AMOUNT_INVALID: {
        title: "We couldn't generate your payment code",
        text: 'Try again to hold your seats and get your code.',
        acceptLabel: 'Got it',
      },
    },
    loadings: {
      bestAvailable: 'Selecting the best seats',
      releasingTickets: 'Releasing your tickets',
      loadingTickets: 'Preparing your tickets...',
      almostAlready: 'Your tickets are almost ready!',
      creatingOxxo: 'Creating OXXO code…',
      pleaseWait: 'Wait a moment please...',
      loadingBillboard: 'Loading billboard...',
      inProgress: 'In progress',
    },
    home: {
      map: {
        instruction: 'Interact from map to see more tickets.',
      },
      alerts: {
        noTickets: 'There are no tickets available',
        noTicketsMsg: 'The event has not started sale or tickets are sold out',
        expired: 'Colorín Colorado, this event is over',
        expiredMsg: 'We invite you to look for great events in',
        linkExpired: 'Expired Link',
        linkExpiredMsg:
          'Oops, the event link they shared with you has already expired. ',
        inactive: 'This event is not available',
        inactiveMsg: 'Keep exploring to find other events you might like.',
        notOnSale: 'You will soon be able to access the event',
        notOnSaleMsg: 'And so get your tickets and live the best experience.',
        soldOut: 'Sold out',
        soldOutMsg:
          'Tickets for this event are sold out, stay tuned for new availability.',
        sorryNoTickets: 'Sorry, there are not enough tickets for {{name}}',
        recaptchaError: 'Error generating recaptcha token',
        minTickets_one: 'You must select at least {{count}} ticket {{name}}',
        minTickets_other: 'You must select at least {{count}} tickets {{name}}',
        maxTickets_one: 'You can select maximum {{count}} ticket {{name}}',
        maxTickets_other: 'You can select maximum {{count}} tickets {{name}}',
      },
      fan: {
        title: 'Sale to fans',
        label: 'Enter your fan password',
      },
      cart: {
        title: 'You will like these seats.',
        desc: 'If you prefer others, select them on the map.',
        selectFromMap: 'Select your seats from the map.',
        instruction:
          'If you want to add more tickets you can add them from the map.',
        seatSelected: 'Row {{parent}} |  {{own}} ',
        seatQuantity: '{{own}} x{{quantity}}',
        ticketsQuantity: 'No. Tickets {{quantity}}',
        ticketsAvailability: '{{availability}} available places',
        price: 'Price: ',
        plusCharge: '+ charges',
        zone: 'Area {{zone}}: {{zoneCount}}/{{max}}',
        soldByZone: 'Sold by area: {{availability}}',
        selectZone: 'Select the area',
        selectZoneDesc: 'Choose how close you will be to the stage',
        quantityTickets_one: '{{count}} Ticket',
        quantityTickets_other: '{{count}} Tickets',
      },
      saturated: {
        changeOver:
          'Your chance to search for other tickets is over, but you still have these tickets set aside.',
        retry:
          'When you return you will lose the tickets reserved in this area. ',
        retry3:
          'but due to high demand there may no longer be any more tickets.',
        timeOut: 'Your session is',
        timeOut2: ' about to expire. ',
        timeOut3:
          'If you do not continue with the purchase, the session will expire and you will lose your place in the purchasing process.',
        timer: 'Have',
        timer3: 'to explore available areas and seats',
        alert: 'Expired time',
        alertText: "We're sorry, your purchase time has expired.",
        retry2_one: ' {{count}} tried ',
        retry2_other: ' {{count}} attempts ',
        timer2_one: ' {{count}} tried ',
        timer2_other: ' {{count}} attempts ',
      },
    },
    billboards: {
      noEvents: 'There are no events.',
      noEvents2:
        'Sound checks are underway, so stay tuned or look for more events ',
      searchByDate: 'Search by date',
      allDates: 'All dates',
      availableDate: 'Available date',
      filterBillboard: 'Filter on billboard',
      loadingEvents: 'Loading events...',
      moreEvents: 'Show more events',
      TicketsFrom: 'Tickets from',
    },
    auth: {
      title: 'Add your contact information',
      subtitle: 'We will send your tickets to the',
      subtitleWallet:
        'You will use this information to access your tickets in the',
      sendBy: 'email address',
      sendByWallet: 'app',
      registered: 'registered',
      formData: 'Ticket delivery information',
      phoneData: 'Verification number',
      formDataWallet: 'Purchase confirmation data',
      phoneDataWallet: 'Cell phone number to access your app and tickets',
      verifyPhone: 'We will send you a code to verify your cell phone number',
      sendWhatsApp: 'Send code by WhatsApp',
      validateSms: 'Verify by SMS',
      validateWhatsApp: 'Verify by Whatsapp',
      validOTP: 'Successfully validated code',
      invalidOTP: 'Invalid code, try again',
      otpExpired: 'Your code expired. Request a new one.',
      checkData: 'Verify your data',
      enterOTP:
        'Enter the 6-digit code that we sent to your cell phone. {{phone}}',
      termsAndConditions1: 'By continuing with the purchase, you accept the',
      termsAndConditions2: 'Purchase Terms',
      termsAndConditions3: 'and our',
      termsAndConditions4: 'Privacy notice',
      termsAndConditionsMobile1:
        'By continuing with the purchase, you accept the',
      termsAndConditionsMobile2: 'and',
      wallet: 'Access your tickets from the app using your cell phone',
      hiUser: 'Hello {{name}}!',
      youAreLogged: 'You are logged in as a seller for this event.',
      alreadyAccount: 'Do you already have an account?',
      signIn: 'Sign in',
      signInSeller: 'Inicia sesión como vendedor',
      logInToTickets: 'Enter your details to receive your tickets.',
      SignAsGuest: 'Sign in as a guest',
      loginSeller: 'You are logged in with your account ',
      loginSeller2: ' as a seller of this event. ',
      loginUser: 'You logged in with ',
      loginUser2:
        ', we will send your tickets to your email, once you finish your purchase process. ',
      forgotPassword: 'Forgot your password?',
      resendCodeIn: 'Forward it on',
      seconds: 'seconds',
      NotReceive: 'Did you not receive it?',
      resendSMS: 'Resend by SMS',
      resendWhatsApp: 'Forward on WhatsApp',
      edit: 'Edit Data',
      loginErrorTitle: 'Error al iniciar sesión',
      loginErrorPhone:
        'Su usuario no cuenta con un número telefónico asociado y es requerido para continuar con el proceso de compra, por favor registre un número telefónico válido en el portal de administración dentro del apartado de Perfíl',
      loginErrorAuth:
        'Su usuario no cuenta con autorización para vender en este evento.',
    },
    customization: {
      useThisName: 'Use the same name for all tickets',
      weWantKnowYouBetter: 'We want to know you better',
      helpUsQuestions:
        'Help us improve the experience by answering some questions',
      namesAssistants: 'Name of attendees',
      customAssistant:
        'You will receive personalized tickets with the names of each attendee',
      noCustom: 'Do not customize',
      getTickets: 'Get tickets',
      ifCustom:
        'If you wish, you can personalize each ticket with the name of the attendees.',
      customTickets: 'Customize tickets',
      nameIt: 'Name it',
      enterTheName:
        'Enter the name that will appear on your ticket: {{ticket}}',
      ticketOf: 'ticket {{name}}',
      ticketNumber: 'Ticket {{number}}',
      saveNames: 'Save Names',
      emailAlreadyUsed: 'This email has already been registered for this event',
    },
    survey: {
      title: 'Registro del asistente',
      subtitle: 'Completa los datos del asistente',
      save: 'Guardar',
      noQuestions: 'No hay preguntas configuradas para este evento.',
      footer: { poweredBy: 'Powered by Boletia' },
      errors: {
        loadError: 'Error al cargar los datos de la encuesta',
        saveError: 'Error al guardar los datos',
      },
    },
    payment: {
      oxxo: 'oxxo',
      cash: 'Cash',
      paymentMethod: 'Payment Method',
      customerInfo: 'Customer information',
      YouOneStepAway: 'You are one step away!',
      justMakePayment: "They're almost yours, just make the payment!",
      enterPaymentInfo: 'Enter payment information',
      completeTheData: 'Complete the information to make the purchase.',
      payNow: 'Pay now',
      createCode: 'Create purchase code',
      getTickets: 'Get tickets',
      createOXXOCode: 'Create OXXO code',
      getBill:
        'To request an invoice you must contact the event organizer directly.',
      creditCard: 'Debit/credit card.',
      cardNumber: 'Card number',
      payWithCard: 'Card payment',
      payOXXO: 'Payment at OXXO',
      payCash: 'Cash payment',
      asSeller:
        'As a seller you can obtain tickets and pay them directly to the event organizer.',
      apartOxxo: 'Reserve your spots and pay at OXXO.',
      showOxxoReference:
        'Show the reference number at any OXXO store to pay for your tickets.',
      minimumPurchase:
        'You need a minimum of {{minimumPurchase}} for this pre-sale',
    },
    msi: {
      short: 'MSI',
      title: 'Months without interest',
      total: 'cash {{total}}',
      paymentCash: 'cash',
      option: '{{option}} months of {{total}}',
      choosePaymentTerm: 'Choose a payment term',
      bank: 'With {{bank}}',
      withoutInterest: 'No interest',
      getPeriod: 'Get up to {{maxOption}} MSI',
      toDate: 'Until the {{day}} of {{month}}',
      preSale: 'PRE-SALE',
      sale: 'SALE',
      preSaleLow: 'Pre-sale',
      exclusivePreSale: 'Exclusive pre-sale',
      details: 'Details',
      with: 'With',
      payTo: 'Pay to',
      participatingCards: 'Participating cards',
      payWith: 'Pay your tickets with {{bank}}',
      min: 'Minimum amount',
      toValidPromo:
        'To make this promotion valid, you need to purchase a minimum of {{minimumPurchase}}',
      paymentPlan: 'x {{paymentPlan}} months without interest',
    },
    coupons: {
      invalid: 'Invalid coupon',
      add: 'Add promotional coupon',
      activeCoupon: 'Activate your coupon',
      haveCoupon: 'I have a coupon ',
      discountAmount: '{{amount}} discount',
      discountPercentage: '{{percentage}}% discount',
      inAllTickets: 'on all tickets',
      inSomeTickets: 'on participating tickets',
    },
    success: {
      title: 'Details of your purchase:',
      embeddedMessage:
        'You can now access your tickets to enter your events, manage your reservation, and much more.',
      successMessage: 'We will send your tickets to:',
      succusMessageWallet: 'We will send your purchase confirmation to:',
      successMessageDisclaimer: 'Did you not receive your tickets?',
      successMessageDisclaimerWallet:
        'Did you not receive your purchase confirmation?',
      successMessageOxxoDisclaimer:
        'Did you not receive your confirmation email?',
      succesMessageDisclaimer1:
        'It might be in your spam folder. Double-check your email address too!',
      successOxxoMessage:
        'Once payment is completed, we will send the tickets to:',
      successOxxoMessageWallet:
        'Once payment is completed, we will send your purchase confirmation to:',
      buyAgain: 'Buy again',
      seeOtherEvents: 'See other events',
      reservationCode: 'Reservation code:',
      oxxoMessage:
        'Run to an OXXO and show your reference number to pay for your tickets',
      oxxoMessage2:
        'You have 24 hours to pay, otherwise your tickets will be released.',
      oxxoReference: 'Your OXXO reference number is: ',
      oxxoExpiration: 'Maturity: ',
      order: 'Order number:',
      oxxoSendEmail:
        'We send you a confirmation email with your OXXO reference number to your email ',
      oxxoSendEmail2:
        'and we will notify you when we receive payment confirmation.',
      success: "That's it! The tickets are yours now!",
      successWallet:
        'To view your tickets, open or download the Boletia App and use the number',
      sendEmailMessage: 'We have sent your tickets to the email',
      tickets_one: ' {{count}} Ticket',
      tickets_other: ' {{count}} Tickets',
      footer:
        'This purchase confirmation is not a ticket and will not grant you access to the event.:',
      embeddedButton: 'View my tickets >',
    },
    rsvp: {
      vipMessage:
        'As a VIP attendee <strong>{{name}}</strong>.  <strong>access to exclusive areas</strong> and buy your tickets from this link.',
      vipMessage2:
        'As a VIP attendee <strong>{{name}}</strong>.  <strong> tickets exclusively through this link. </strong> Take advantage of your special access now',
      vipEvent: 'Exclusive event',
      vipTickets: 'Only you can access and buy tickets.',
    },
  },
};

export default en;
